<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <!-- {{profileArr}} -->
                  <div class="col-sm-12">
                    <h3 class="page-title">Affiliate Program</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4">
                      <img style="width:100%" src="@/assets/promo/afil.jpeg" />
                    </div>
                    <div class="col-md-8">
                      <h3>Hasilkan Lebih Banyak Uang dengan Bergabung Jadi Affiliate {{appTitle}}</h3>
                      <p>Dapatkan kesempatan mendapatkan komisi secara recurring atau berulang setiap bulan dengan menjadi affiliate di {{appTitle}}</p>
                      <div class="text-center">
                        <button @click="join" :disabled="isLoading" class="btn btn-md btn-dark">
                          <i class="fa fa-users"></i> Daftar Sekarang
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <h3>F.A.Q - Pertanyaan Umum</h3>
                  <faq />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
// import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import LayoutSidebarPromotion from "@/components/layouts/Sidebar.vue";

import Faq from "./components/faq.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
    Faq
  },
  computed: {
    memberSession() {
      return this.$store.state.login.memberSession;
    },
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    }
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      isLoading: false
    };
  },
  async created() {
    if (this.isJoinAffiliate == true) {
      this.$router.push({ path: "/referral/link" });
    }
  },
  methods: {
    async join() {
      this.isLoading = await true;
      await this.$fire({
        title: "Are you sure you will join The Affiliate Program?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("referral/join")
            .then(async response => {
              await this.$store.dispatch("referral/check");
              await this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
              await this.$router.push({ path: "/referral/link" });
              this.isLoading = await false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
      this.isLoading = await false;
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "referral"
};
</script>


// WEBPACK FOOTER //
// src/views/referral/index.vue